var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9872 23.6916C25.6836 23.6916 26.25 24.2653 26.25 24.9708C26.25 25.6776 25.6836 26.25 24.9872 26.25H17.8496C17.1532 26.25 16.5868 25.6776 16.5868 24.9708C16.5868 24.2653 17.1532 23.6916 17.8496 23.6916H24.9872ZM20.0373 4.62383L21.8811 6.08848C22.6372 6.67972 23.1412 7.45907 23.3136 8.27874C23.5126 9.18037 23.3004 10.0659 22.7035 10.8318L11.7205 25.0349C11.2164 25.6799 10.4736 26.0427 9.67777 26.0561L5.30049 26.1099C5.06173 26.1099 4.86277 25.9486 4.80971 25.7202L3.81487 21.4068C3.64243 20.6141 3.81487 19.7944 4.31892 19.1628L12.1052 9.08497C12.2378 8.92372 12.4766 8.89819 12.6357 9.01778L15.9121 11.6246C16.1243 11.7993 16.4161 11.8933 16.7212 11.853C17.3712 11.7724 17.8089 11.1812 17.7426 10.5496C17.7028 10.2271 17.5436 9.95838 17.3314 9.75682C17.265 9.70308 14.1479 7.20376 14.1479 7.20376C13.9489 7.04252 13.9091 6.7469 14.0683 6.54669L15.3019 4.94632C16.4426 3.48167 18.4323 3.3473 20.0373 4.62383Z",
    fill: "#004A2F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPencil);
export default __webpack_public_path__ + "static/media/IconPencil.1fa4e0318d3727c8645b1206ab0a6671.svg";
export { ForwardRef as ReactComponent };